import React from "react";

interface ButtonProps {
  type: "submit" | "reset" | "button" | undefined;
  titleButton: string;
  icon?:any;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({ type, titleButton, className,icon }) => {
  return (
    <button type={type} className={className}>
      {icon}{titleButton}
    </button>
  );
};

export default Button;
